namespace TabAurous.Production {
    export interface DismantlingBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        RefTransBomId?: number;
        ProductId?: number;
        BOMProductId?: number;
        BOMAttributeId?: number;
        CertificateNo?: string;
        BagNo?: string;
        LotNo?: string;
        Lab?: string;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        SettingId?: number;
        BomRate?: number;
        BomAmount?: number;
        Remarks?: string;
        Purity?: number;
        PureWeight?: number;
        IsCustomerItem?: boolean;
        Markup?: number;
        PointerWeight?: number;
        ProductCode?: string;
        ProductName?: string;
        ItemType?: string;
        CalcOn?: string;
        HasBom?: boolean;
        ItemTypeId?: number;
        ProductTypeId?: number;
        SubCategoryId?: number;
        CategoryId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
    }

    export namespace DismantlingBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'CertificateNo';
        export const localTextPrefix = 'Production.DismantlingBOM';
        export const deletePermission = 'Production:Dismantling:Delete';
        export const insertPermission = 'Production:Dismantling:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Dismantling:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            RefTransBomId = "RefTransBomId",
            ProductId = "ProductId",
            BOMProductId = "BOMProductId",
            BOMAttributeId = "BOMAttributeId",
            CertificateNo = "CertificateNo",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Lab = "Lab",
            Pieces = "Pieces",
            Weight = "Weight",
            CalcOnId = "CalcOnId",
            SettingId = "SettingId",
            BomRate = "BomRate",
            BomAmount = "BomAmount",
            Remarks = "Remarks",
            Purity = "Purity",
            PureWeight = "PureWeight",
            IsCustomerItem = "IsCustomerItem",
            Markup = "Markup",
            PointerWeight = "PointerWeight",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            ItemType = "ItemType",
            CalcOn = "CalcOn",
            HasBom = "HasBom",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            SubCategoryId = "SubCategoryId",
            CategoryId = "CategoryId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth"
        }
    }
}
